import React from 'react';
import PropTypes from 'prop-types';

const LocationText = props => <span>{props.data.location_text}</span>;

LocationText.propTypes = {
	data: PropTypes.object.isRequired,
};

export default LocationText;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/location-text.js